export default __webpack_public_path__ + "static/water_filter_b.46219a9020a034d5f02166bd98f366e1.svg";